import ChangeTagsModal from './ChangeTagsModal.component';
import ManageTagsModal from './ManageTagsModal.component';
import TagCellRenderer from './TagCellRenderer.component';

export default { ChangeTagsModal, ManageTagsModal, TagCellRenderer };
